import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import LazyLoad from "react-lazyload"
import HIPAALogo from "../assets/images/hippaaLogo.png"
import SOCLogo from "../assets/images/SOC_logo.png"
import logoIcon from "../assets/images/spsFooterLogoNew.svg"
import "../styles/component/footer.scss"
import FormBuilder from "./common/FormBuilder/Form-Builder"
import Links from "./common/links"
import SVGIcon from "./common/SVGIcon"
import { checkIndAndAbroadTime, slugChecker } from "./common/util-functions"
import "./utility/current_domain"

function Footer (props) {
  const data = FooterQuery()
  const {
    pageBlock,
    showHellobar,
    pageSlugs,
    footerComponent,
  } = data.SuperOps.pages[0]

  const [userCountryCode, setUserCountryCode] = useState()
  const [footerData, setFooterData] = useState(null)

  useEffect(() => {
    async function fetchIPCountryCode() {
      try {
        const res = await fetch(process.env.IP_STACK_API)
        const data = await res.json()
        if (data && data.country_code) {
          setUserCountryCode(data?.country_code)
        } else {
          console.warn("country_code is missing in IPStack response:", data)
        }
      } catch (error) {
        console.error("Failed to fetch IPStack data:", error)
      }
    }

    fetchIPCountryCode()
  }, [])

  const footers = footerComponent || []

  useEffect(() => {
    if (!userCountryCode || !footers.length) return

    const getFooterData = (footers, userCountryCode) => {
      const matched = footers.find(foot => foot.countryCode === userCountryCode)
      if (matched) return matched

      const defaultFooter = footers.find(foot => foot.countryCode === "default")
      return defaultFooter || {} // return empty object if no default
    }

    const result = getFooterData(footers, userCountryCode)
    setFooterData(result)
  }, [userCountryCode, footers])

  const [showFooterImg, setShowFooterImg] = useState(false)

  useEffect(() => {
    if (!footerData || !Object.keys(footerData).length) return

    const { slug, eventTime } = footerData
    const heroImage = footerData?.image
    const footerView = footerData?.footerView === "block" ? false : true

    if (
      slug &&
      heroImage &&
      (eventTime ? checkIndAndAbroadTime(eventTime) : true) &&
      slugChecker(showHellobar, pageSlugs) &&
      footerView
    ) {
      setShowFooterImg(true)
    }
  }, [footerData, showHellobar, pageSlugs])

  const date = new Date()
  const currentYear = date.getFullYear()

  return (
    <div
      className={`Footer ${props.footerClass ? props.footerClass : ""}  ${
        props.theme === "dark" ? "transparent-footer" : ""
      }`}
    >
      <div
        className={`Layout-container${props.bigFooter ? "-big" : ""} mx-auto`}
      >
        {/* MOBILE FOOTER */}
        <div className='d-mob'>
          <div className='banner-wrapper'>
            {showFooterImg && footerData && (
              <a href={footerData.slug} target="_blank">
                <img
                  src={footerData.image?.url}
                  className='w-100 br10'
                  alt='notice-cover'
                  loading='lazy'
                />
              </a>
            )}
          </div>
          <LazyLoad throttle={200} height={200}>
            <Link href='/' rel='noopener'>
              <img
                src={logoIcon}
                alt='logo'
                className='footer-logo objcvr'
                width='10'
                height='10'
                loading='lazy'
              />
            </Link>
          </LazyLoad>
          <div className='tagline'>{parse(pageBlock[0].content.html)}</div>

          <Row className='justify-content-between'>
            <Col sm={12} lg={8}>
              <Row>
                <Col xs={6} lg={3}>
                  {[
                    data.SuperOps.links[0],
                    data.SuperOps.links[1],
                    data.SuperOps.links[3],
                    data.SuperOps.links[4],
                  ].map((el, idx) => {
                    return (
                      <>
                        <FooterLinks element={el} />
                      </>
                    )
                  })}
                </Col>
                <Col xs={6} lg={3}>
                  {[
                    data.SuperOps.links[2],
                    data.SuperOps.links[5],
                    data.SuperOps.links[6],
                  ].map((el, idx) => {
                    return (
                      <>
                        <FooterLinks element={el} />
                      </>
                    )
                  })}
                </Col>
              </Row>
            </Col>

            <Col sm={12}>
              <NewsLetter newButton={props.newButton} />

              <FooterSocial items={data.SuperOps.links[7]} />
              <div className='certificates d-flex mb24'>
                <img
                  src={SOCLogo}
                  alt='SOC_Logo'
                  className='logo'
                  loading='lazy'
                />
                <img
                  src={HIPAALogo}
                  alt='HIPAA_Logo'
                  className='logo'
                  loading='lazy'
                />
                <img
                  src='https://us-west-2.graphassets.com/AsRMKMrtKTFW6TGbr4KgUz/cmaf8sx3u8glc07llsvsybyf7'
                  alt='ISO_Logo'
                  className='logo'
                  loading='lazy'
                />
              </div>

              <p className='rights-reserved'>
                © {currentYear} SuperOps. All rights reserved
              </p>

              <LegalLinks items={data.SuperOps.links[8]} />

              <p className='rights-reserved'>
                Contact us: +1 628-270-9924 | +44 20 4525 2090
              </p>
            </Col>
          </Row>
        </div>
        {/* MOBILE FOOTER END */}

        {/* Desktop Footer */}
        <div className='d-dsk'>
          <Row className='justify-content-between'>
            <Col lg={props.bigFooter ? 2 : 3} className='prelative'>
              {showFooterImg && footerData && (
                <Link to={footerData.slug} target="_blank">
                  <img
                    src={footerData.image?.url}
                    className='w-100 br10'
                    alt='notice-cover'
                    loading='lazy'
                  />
                </Link>
              )}
              <div className='superops-logo'>
                <LazyLoad throttle={200} height={200}>
                  <Link href='/' rel='noopener'>
                    <img
                      src={logoIcon}
                      alt='logo'
                      className='footer-logo objcvr'
                      width='10'
                      height='10'
                      loading='lazy'
                    />
                  </Link>
                </LazyLoad>
                <div className='tagline'>
                  {parse(pageBlock[0].content.html)}
                </div>

                <p className='rights-reserved'>
                  © {currentYear} SuperOps. All rights reserved
                </p>
              </div>
            </Col>
            <Col lg={props.bigFooter ? 9 : 8}>
              <Row>
                <Col lg={3}>
                  {[data.SuperOps.links[0], data.SuperOps.links[1]].map(
                    (el, idx) => {
                      return (
                        <>
                          <FooterLinks element={el} />
                        </>
                      )
                    }
                  )}
                </Col>
                <Col lg={3}>
                  {[data.SuperOps.links[2]].map((el, idx) => {
                    return (
                      <>
                        <FooterLinks element={el} />
                      </>
                    )
                  })}
                </Col>
                <Col lg={3}>
                  {[data.SuperOps.links[3], data.SuperOps.links[4]].map(
                    (el, idx) => {
                      return (
                        <>
                          <FooterLinks element={el} />
                        </>
                      )
                    }
                  )}
                </Col>
                <Col lg={3}>
                  {[data.SuperOps.links[5], data.SuperOps.links[6]].map(
                    (el, idx) => {
                      return (
                        <>
                          <FooterLinks element={el} />
                        </>
                      )
                    }
                  )}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className='justify-content-between mt16'>
            <Col lg={3} className='position-relative align-self-center'>
              <div className='certificates d-flex'>
                <img
                  src={SOCLogo}
                  alt='SOC_Logo'
                  className='logo'
                  loading='lazy'
                />
                <img
                  src={HIPAALogo}
                  alt='HIPAA_Logo'
                  className='logo'
                  loading='lazy'
                />
                <img
                  src='https://us-west-2.graphassets.com/AsRMKMrtKTFW6TGbr4KgUz/cmaf8sx3u8glc07llsvsybyf7'
                  alt='ISO_Logo'
                  className='logo'
                  loading='lazy'
                />
              </div>
            </Col>
            <Col lg={4}>
              <NewsLetter />
              <div className='Legal-links'>
                {data.SuperOps.links[8].linkName.map((el, idx) => {
                  return <Link to={data.SuperOps.links[8].slug[idx]}>{el}</Link>
                })}
              </div>
            </Col>

            <Col lg={3}>
              <FooterSocial items={data.SuperOps.links[7]} iconOnly />
              <p className='rights-reserved contact'>
                Contact us: +1 628-270-9924 | +44 20 4525 2090
              </p>
            </Col>
          </Row>
        </div>

        {/* Desktop Footer End*/}
      </div>
    </div>
  )
}

export default Footer

export function FooterQuery () {
  const returneddata = useStaticQuery(graphql`
    query contentFooter {
      SuperOps {
        pages(where: { title: "Footer Block" }) {
          heroImage {
            url
          }
          slug
          pageBlock {
            id
            content {
              html
            }
          }
          eventTime
          showHellobar
          pageSlugs
          footerComponent: helloBar {
            ... on SuperOps_HelloBarComponent {
              countryCode
              eventTime
              slug
              image {
                url
              }
              footerView: helloBarView
            }
          }
        }

        links(where: { where: "Footer-V2" }) {
          section
          sectionLink
          linkName
          slug
          icon {
            url
          }
        }
      }
    }
  `)
  return returneddata
}

const FooterLinks = props => {
  return (
    <div className='Link-section'>
      {props.element.section && (
        <div className='section-title'>
          {props.element.sectionLink ? (
            <>
              <Link
                to={props.element?.sectionLink}
                className='link d-flex align-items-center fw-bold'
              >
                {props.element.section}
                <SVGIcon name='hypertext-arrow-right' className='arrow-right' />
              </Link>
            </>
          ) : (
            <p className='text fw-bold'>{props.element.section}</p>
          )}
        </div>
      )}

      <div className='child-links'>
        <Links items={props.element} />
      </div>
    </div>
  )
}

const NewsLetter = props => {
  return (
    <div className='Newsletter'>
      <p className='text fw-bold'>Subscribe to our newsletter</p>
      <FormBuilder
        errorClassName='error-message'
        inputClassName='input-sm'
        inputErrorClassName='error-active'
        buttonText='SUBSCRIBE'
        buttonClassName={`primary${props.newButton ? "-new" : ""} sm w-100`}
        type='subscribe'
        path='subscription'
      />
    </div>
  )
}

const FooterSocial = props => {
  return (
    <div className='Footer-Social'>
      <p>Follow us on</p>
      <div className='d-flex'>
        <Links items={props.items} iconOnly />
      </div>
    </div>
  )
}

const LegalLinks = props => {
  return (
    <div className='Legal-links'>
      <Row>
        {props.items.linkName.map((el, idx) => {
          return (
            <Col xs={4} lg={3}>
              <Link to={props.items.slug[idx]}>{el}</Link>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
